import styled, { css } from 'styled-components';

export const DeleteButton = styled.button`
  ${({ theme }) => css`
    svg {
      color: ${theme.colors.danger};
    }
  `}
`;
